import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class BdspCreativeService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_BDSP_URL}/creative/`;

  getCreativeSizes(params = {}) {
    let url = this.buildUrl(`${this.resource_url}sizes/`, "", params);
    return this.get(url);
  }

  crtvStatusUpdate(action: 'activate' | 'deactivate', id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/${action}/`, '', params);
    return this.put(url, {});
  }
}
